import { alpha, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: 0,
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  fieldsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "10px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "4px",
    minWidth: 0,
  },
  label: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
    textAlign: "right",
    width: "100%",
    fontFamily: "Noto Sans Hebrew",
  },
  input: {
    width: "100%",
    direction: "ltr",
    "& .MuiOutlinedInput-root": {
      height: "48px",
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      backgroundColor: theme.palette.background.paper,
      borderRadius: "4px",
      direction: "ltr",
      boxSizing: "border-box",
      "& fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.divider,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.divider,
        borderWidth: "1px",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontWeight: 400,
      fontStyle: "normal",
      fontSize: "14px",
      lineHeight: "140%",
      letterSpacing: 0,
      textAlign: "right",
      verticalAlign: "middle",
      color: theme.palette.secondary.main,
      leadingTrim: "cap-height",
      padding: "12px 16px 12px 8px",
      direction: "rtl",
      boxSizing: "border-box",
      fontFamily: "Noto Sans Hebrew",
    },
  },
  divider: {
    height: "1px",
    backgroundColor: theme.palette.divider,
  },
  summaryRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    direction: "ltr",
    gap: "12px",
  },
  summaryLabel: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    color: theme.palette.secondary.main,
    textAlign: "right",
    fontFamily: "Noto Sans Hebrew",
  },
  summaryPill: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    borderRadius: "16px",
    padding: "2px 12px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    fontFamily: "Noto Sans Hebrew",
  },
  saveButton: {
    width: "100%",
    height: "48px",
    minHeight: "48px",
    borderRadius: "4px",
    padding: "10px 16px",
    gap: "6px",
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    boxShadow: "none",
    boxSizing: "border-box",
    fontFamily: "Noto Sans Hebrew",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
}));
